import { render, staticRenderFns } from "./ModalContactsSuppliers.vue?vue&type=template&id=9e226a4a&lang=pug&"
import script from "./ModalContactsSuppliers.vue?vue&type=script&lang=js&"
export * from "./ModalContactsSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports